import { useUserInfoQuery } from "Auth/Api/Queries/useUserInfoQuery";
import { ProgramParticipationState } from "Infrastructure/Api/Api";

type ReturnType = {
  /** Undefined until user-info is known — callers wait, they never read "unknown" as "no". */
  hasStardustConsent: boolean | undefined;
  isLoading: boolean;
  isError: boolean;
};

/**
 * Whether the current person is in the Stardust program (ZS-1624, legal 2026-09-29): the one place
 * that reads the consent out of user-info, so pages, gates and the loyalty hooks agree on it. Read
 * from the React Query user-info, not the Redux user — after an SPA sign-in the Redux user is built
 * from SignInResult, which carries no participation. The participation mutation invalidates the
 * query, so consenting or leaving re-renders every consumer.
 */
export const useHasStardustConsent = (): ReturnType => {
  const { data: userInfo, isLoading, isError } = useUserInfoQuery();

  const hasStardustConsent =
    userInfo === undefined
      ? undefined
      : userInfo.stardustParticipation === ProgramParticipationState.OptedIn;

  return { hasStardustConsent, isLoading, isError };
};
